import type React from "react"
import type { DerivationProps } from "../interfaces/DerivationProps"

interface ExtendedDerivationProps extends DerivationProps {
  isNew?: boolean
}

export const DerivationPreview: React.FC<ExtendedDerivationProps> = ({
  derivationData,
  onSelect,
  selectedDerivation,
  isNew,
}) => {
  const date = new Date(derivationData.dt)
  const formattedDate = date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  })

  const formattedTime = date.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })

  return (
    <button
      className={`relative block w-full p-4 transition-all duration-200 rounded-lg text-left overflow-hidden border border-transparent ${
        selectedDerivation?.id === derivationData.id
          ? "bg-orange-100 border-orange-300 shadow-sm"
          : "hover:bg-orange-50 hover:border-orange-200"
      }`}
      onClick={() => onSelect(derivationData)}
    >
      {isNew && (
        <span className="absolute top-2 right-2 bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
          SIN ABRIR
        </span>
      )}

      <div className="text-sm font-semibold text-gray-800 mb-2">{formattedDate}</div>

      <div className="flex justify-between items-center">
        <div className="flex items-center bg-gray-100 px-2 py-1 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-3 h-3 text-gray-500 mr-1"
          >
            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z" />
          </svg>
          <span className="text-xs font-medium text-gray-600">{formattedTime}</span>
        </div>

        <div className="flex items-center bg-green-50 px-2 py-1 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            fill="currentColor"
            className="w-3 h-3 text-green-600 mr-1.5"
          >
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
          </svg>
          <span className="text-sm font-medium text-gray-700 truncate max-w-[160px]">{derivationData.from}</span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-orange-200 to-transparent" />
    </button>
  )
}

